import { render, staticRenderFns } from "./addTask.vue?vue&type=template&id=f3cd2f34&scoped=true"
import script from "./addTask.vue?vue&type=script&lang=js"
export * from "./addTask.vue?vue&type=script&lang=js"
import style0 from "./addTask.vue?vue&type=style&index=0&id=f3cd2f34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3cd2f34",
  null
  
)

export default component.exports